/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type BuySharedItemTrackingProvider_buyPage$ref = any;
export type BuySharedItemTrackingProvider_buyPage = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly serviceId: string | null;
            readonly title: string | null;
            readonly categoryPath: string | null;
            readonly browseUrl: string | null;
            readonly categoryCode: string | null;
            readonly contemporaryTrackingString: string;
            readonly seller: {
                readonly serviceId: string | null;
            } | null;
            readonly displayPriceTracking: ReadonlyArray<{
                readonly convertedAmountList: ReadonlyArray<{
                    readonly amount: number | null;
                    readonly currency: Currency | null;
                } | null> | null;
                readonly type: string | null;
            } | null> | null;
        } | null;
    } | null> | null;
    readonly " $refType": BuySharedItemTrackingProvider_buyPage$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "BuySharedItemTrackingProvider_buyPage",
        "type": "BuyPageConnection",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isTrade",
                "type": "Boolean"
            }
        ],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "BuyPageEdge",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "title",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "categoryPath",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "browseUrl",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "categoryCode",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "contemporaryTrackingString",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "seller",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Seller",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/)
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "alias": "displayPriceTracking",
                                "name": "displayPrice",
                                "storageKey": null,
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "isTrade",
                                        "variableName": "isTrade"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "page",
                                        "value": "searchAndBrowse"
                                    }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "convertedAmountList",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "ConvertedAmountList",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "amount",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "currency",
                                                "args": null,
                                                "storageKey": null
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "type",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'e12fba7a1cbab9bfa69738cb5d1c350c';
export default node;
